import React from 'react';
import { VvConnectFeesDto } from '../../../../slices/marketplace/loi-comparison/models/vv-connect-fees.model';
import Helpers from '../../../../utils/helper';

export interface FeeRowConfig {
    label: string;
    key: keyof VvConnectFeesDto;
    format: 'currency' | 'percent';
    isBold?: boolean;
}

export const getFeeRows = (showFairValue: boolean): FeeRowConfig[] => [
    { label: 'Transaction Fee %', key: 'transactionFeePercent', format: 'percent' },
    { label: showFairValue ? 'Transaction Fair Value' : 'Transaction Face Value', key: 'transactionFairValue', format: 'currency' },
    { label: 'Transaction Fee $', key: 'transactionFeeDollar', format: 'currency' },
    { label: 'Application Fee', key: 'applicationFee', format: 'currency' },
    { label: 'Monthly Retainer Fees', key: 'monthlyRetainerFees', format: 'currency' },
    { label: 'Process Fees', key: 'processFees', format: 'currency' },
    { label: 'Late / Delay Fees', key: 'lateDelayFees', format: 'currency' },
    { label: 'Engagement Suspention Fees', key: 'engagementSuspensionFees', format: 'currency' },
    { label: 'Total Net Fee', key: 'totalNetFee', format: 'currency', isBold: true },
    { label: showFairValue ? '% of Fair Value' : '% of Face Value', key: 'percentOfFairValue', format: 'percent', isBold: true },
    { label: 'Net Fee Payment at Closing', key: 'netFeePaymentAtClosing', format: 'currency', isBold: true },
];

const formatFeeCurrency = (value: number | null | undefined): string => {
    if (value == null) return '';
    if (value === 0) return '$0';
    return Helpers.currencyFormat(value, false);
};

const formatFeePercent = (value: number | null | undefined): string => {
    if (value == null) return '';
    return `${parseFloat(value.toFixed(2))}%`;
};

interface VvConnectFeesSectionProps {
    fees: VvConnectFeesDto | null;
}

export const VvConnectFeesSection = ({ fees }: VvConnectFeesSectionProps) => {
    return (
        <table className="vv-connect-fees-table">
            <thead>
                <tr>
                    <th className="sub-col-header">Fee</th>
                    <th className="sub-col-header">Credits</th>
                </tr>
            </thead>
            <tbody>
                {getFeeRows(true).map((row) => {
                    const rowData = fees?.[row.key];
                    const feeStr = row.format === 'percent'
                        ? formatFeePercent(rowData?.fee)
                        : formatFeeCurrency(rowData?.fee);
                    const creditsStr = row.format === 'currency'
                        ? formatFeeCurrency(rowData?.credits)
                        : '';

                    const rowClassName = row.isBold ? 'total-row' : undefined;

                    return (
                        <tr key={row.key} className={rowClassName}>
                            <td className="cell-value">{feeStr}</td>
                            <td className="cell-value">{creditsStr}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};
